export default "/_next/static/images/bb61aa2e21d104564b672115f6fb0457.png";